import { gql } from '@apollo/client';

const GET_LOYALTY_TIERS = gql`
  query getFrequentFoodiesTiers($siteId: Int) {
    tiers: allLoyaltyTiers(siteId: $siteId) {
      id
      title
      description
      pointsRequiredToUpgrade
      benefits {
        title
        customValue
        description
      }
    }
  }
`;

const GET_LOYALTY_PROFILE = gql`
  query getFrequentFoodiesProfile {
    user: Member {
      id
      created
      firstName
      surname
      currentLoyaltyTier {
        id
        startDate
        endDate
        pointsEarned
        pointsRequired
        percentageComplete
        definition {
          id
          title
        }
      }
      nextLoyaltyTier {
        id
        pointsEarned
        pointsRequired
        percentageComplete
        definition {
          id
          title
        }
      }
    }
  }
`;

const GET_LOYALTY_EARN_DEFINITIONS = gql`
  query getLoyaltyEarnDefinitions($siteId: Int) {
    earnDefinitions: allLoyaltyEarnDefinitions(siteId: $siteId) {
      id
      title
      marketingDescription
      points
    }
  }
`;

const GET_LOYALTY_TRANSACTIONS = gql`
  query getLoyaltyTransactions {
    user: Member {
      id
      transactions(currency: "FFP") {
        edges {
          node {
            id
            created
            title
            amount
            status
          }
        }
      }
    }
  }
`;

export {
  GET_LOYALTY_TIERS,
  GET_LOYALTY_PROFILE,
  GET_LOYALTY_EARN_DEFINITIONS,
  GET_LOYALTY_TRANSACTIONS,
};
